import { GxIcon } from './icon.js'



export class GxIconGauge extends GxIcon {

  constructor() {
    super()
    const temp = document.createElement("template")
    temp.innerHTML = `
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" 
  stroke="currentColor" stroke-width="2" 
  stroke-linecap="round" stroke-linejoin="round"  aria-hidden="true">
  <path d="m12 14 4-4"></path>
  <path d="M3.34 19a10 10 0 1 1 17.32 0"></path>
</svg>
`
    super.addHTML(temp)
  }
}


if (!window.customElements.get("gx-icon-gauge")) window.customElements.define("gx-icon-gauge", GxIconGauge)
